import { EvidencePayloadType, EvidenceType } from "src/app/services/evidence.service";
import { IOrgUser } from "src/app/services/user.service";

export interface PerformLogBackend {
  logID?: string,
  orgID?: string,
  occurDate: string,
  // orgUserID?: string,
  staffUserID: string,
  managerID: string,
  category: PERFORM_LOG_TYPE_ENUM,
  action?: PERFORM_LOG_ACTION_ENUM,
  note: string,
  notes?: EvidenceType[],
  createDate?: string,
  updateDate?: string,
  createdBy?: string,
  updatedBy?: string,
  standards?: string[],
  orgStandards?: string[],
  sentiment?: PerformLogSentiment,
}

export interface PerformLogForm extends PerformLogBackend{
  orgUserID?: string,
  evidences?: PerformLogEvidence[],
}

export interface IPerformLog extends PerformLogBackend, IOrgUser {
  staffOrgUser: IOrgUser;
  managerOrgUser: IOrgUser;
  createdByOrgUser: IOrgUser;
  evidences?: PerformLogEvidence[],
}

export enum PERFORM_LOG_TYPE_ENUM {
  attitudeOrBehaviour = 'Attitude / Behaviour',
  performance = 'Performance',
  professionalism = 'Professionalism',
  timeAndAttendance = 'Time / Attendance',
  other = 'Other',
}

export const PERFORM_LOG_TYPE_DISPLAY_DICT: Record<PERFORM_LOG_TYPE_ENUM, string> = {
  [PERFORM_LOG_TYPE_ENUM.attitudeOrBehaviour]: 'Attitude / Behaviour',
  [PERFORM_LOG_TYPE_ENUM.performance]: 'Performance',
  [PERFORM_LOG_TYPE_ENUM.professionalism]: 'Professionalism',
  [PERFORM_LOG_TYPE_ENUM.timeAndAttendance]: 'Time and Attendance',
  [PERFORM_LOG_TYPE_ENUM.other]: 'Other',
};

export enum PERFORM_LOG_ACTION_ENUM {
  requestToMeet = 'Request to Meet',
  investigation = 'Investigation',
  passedToHR = 'Passed to HR',
  monitor = 'Monitor',
  other = 'Other',
}

export const PERFORM_LOG_ACTION_DISPLAY_DICT: Record<PERFORM_LOG_ACTION_ENUM, string> = {
  [PERFORM_LOG_ACTION_ENUM.requestToMeet]: 'Request to Meet',
  [PERFORM_LOG_ACTION_ENUM.investigation]: 'Investigation',
  [PERFORM_LOG_ACTION_ENUM.passedToHR]: 'Passed to HR',
  [PERFORM_LOG_ACTION_ENUM.monitor]: 'Monitor',
  [PERFORM_LOG_ACTION_ENUM.other]: 'Other',
};

export type PerformLogSentiment = 'Positive' | 'Constructive' | 'Neutral';
export const PerformLogSentimentList: PerformLogSentiment[] = ['Positive', 'Neutral', 'Constructive']
export const PerformLogSentimentDisplay: { [k in PerformLogSentiment]: string } = {
  'Neutral': '😶 Neutral',
  'Positive': '👍 Positive',
  'Constructive': '👷 Constructive',
}
export const PERFORM_LOG_SENTIMENT_OPTIONS = PerformLogSentimentList.map(el => ({ label: PerformLogSentimentDisplay[el], value: el }));


export interface PerformLogEvidence {
  noteID?: string,
  title: string,
  link: string,
  description?: string,
  managerUserID: string,
  createTime: string,
}
